var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "msg" }, [
    _vm._v(_vm._s(_vm.fileMsg || "只能上传jpg/png文件，且不超过2MB")),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }